import { Button } from '@mui/material';
import { PermissibleRender } from '../PermissibleRender';
import { Permission } from '../../../store/GeneralStore';

export const NewEngagementButton = ({ onClick }: { onClick: () => void }) => (
  <PermissibleRender requiredPermissions={[Permission.ADVISE_FULL]}>
    <Button
      variant="contained"
      size="small"
      onClick={onClick}>
      New Engagement
    </Button>
  </PermissibleRender>
);
